import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import DOMPurify from "dompurify";
import {
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  Autocomplete,
  TextField,
  InputLabel,
  Button,
  Select,
  MenuItem,
  FormControl,
  Box,
  Grid,
  Typography,
  Checkbox,
} from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { handleValidationForm, validateFieldOnChange } from "utils/utils";
import BootstrapInput from "./CommonFormStyle";
import Loader from "components/loader/Loader";
import CommonCropUpload from "components/commonCropUpload/CommonCropUpload";
import CustomTextfield from "components/customTextfield/CustomTextfield";
import CommonCropImage from "components/commonCropImage/CommonCropImage";
import DateTab from "pages/date/Date";
import {
  userOption,
  flatoptions,
  referralOption
} from "pages/configuration/coupon/CouponFormData";
import { imageSize, pdfDocReg, csvReg } from "utils/Regex";
import profile from "assets/images/SubVendorLogo.svg";
import cloudArrowUp from "assets/images/cloudArrowUp.svg";
import lockicon from "assets/images/lockicon.svg";
import downloadBlue from "assets/images/DownloadSimple.svg";
import camera from "assets/images/camera.svg";
import profileImg from "assets/images/ProfileVendor.svg";

export default function CommonForm(props) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    clearErrors,
    control,
    getValues,
    watch,
  } = useForm({ defaultValues: props?.defaultValues });
  const [formError, setFormError] = useState([]);
  const [isDisabled, setIsDisabled] = useState(
    props?.selectType === "edit" ? false : true
  );
  const [formData, setFormData] = useState(() => {
    const data = props?.formData || [];
    return props?.formName === "couponForm" 
      ? data.filter(field => field.name !== "subscriptionPlanId") 
      : data;
  });
  const { users, csvFile } = userOption();
  // ---Country Code---
  const [country, setCountry] = useState("+91");
  const [facilities, setFacilities] = useState(() => {
    // Generic initialization of array fields from defaultValues
    const initialState = {};
    if (props?.defaultValues) {
      // Handle both direct field names and alternative names (like Services for dutyTypes)
      Object.keys(props?.defaultValues).forEach(key => {
        if (Array.isArray(props?.defaultValues[key])) {
          initialState[key] = props?.defaultValues[key];
          // Handle special case mappings
          if (key === 'Services') {
            initialState['dutyTypes'] = props?.defaultValues[key];
          }
          if (key === 'ServiceCities') {
            initialState['city'] = props?.defaultValues[key];
          }
        }
      });
    }
    return initialState;
  });
  const [selectValues, setSelectValues] = useState({});
  const [image, setImage] = useState({ name: "", file: "" });
  const [fileTypeError, setFileTypeError] = useState("");
  const [imgError, setImgError] = useState("");
  const [discountTypeLabel, setDiscountType] = useState("");
  const [csv, setCsv] = useState({ name: "", file: "" });
  const [fileCsvTypeError, setFileCsvTypeError] = useState("");
  const [csvError, setCsvError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [src, setSrc] = useState(null);
  const [imageCrop, setImageCrop] = useState(null);
  const [imageObj, setImageObj] = useState({});
  const [imgPlaceholder, setImgPlaceholder] = useState(true);
  const [showAsBannerState, setShowAsBannerState] = useState(false);
  const [bannerPriorityState, setBannerPriorityState] = useState("");
  const [vehicleerrors, setVehicleErrors] = useState({});

  const setupFormFields = (defaultValues, currentFormData) => {
    const { category, discountType } = defaultValues;
    let tempFormData = [...currentFormData];

    // Find the category field index
    const categoryIndex = tempFormData.findIndex(field => field.name === "category");

    if (categoryIndex === -1) return tempFormData;

    // Remove all dynamic fields first
    tempFormData = tempFormData.filter(field =>
      field.name !== "referralType" &&
      field.name !== "isNewUser" &&
      field.name !== "CsvFile" &&
      field.name !== "subscriptionPlanId"
    );

    // Handle Subscription category - hide city, dutyTypes, duration, usage limits
    if (category === "Subscription") {
      tempFormData = tempFormData.filter(field =>
        field.name !== "city" &&
        field.name !== "dutyTypes" &&
        field.name !== "duration" &&
        field.name !== "individualUsageLimit" &&
        field.name !== "overallUsageLimit"
      );
    }

    // Insert category-specific fields right after category
    const updatedCategoryIndex = tempFormData.findIndex(field => field.name === "category");
    let insertIndex = updatedCategoryIndex + 1;

    if (category === "Individual") {
      // Add CSV field for Individual category
      tempFormData.splice(insertIndex, 0, csvFile);

    } else if (category === "Flash") {
      // Add user radio field and banner fields for Flash category
      tempFormData.splice(insertIndex, 0, users);

    } else if (category === "Referral") {
      // Add referral type radio buttons for Referral category
      tempFormData.splice(insertIndex, 0, referralOption().referralType);
    } else if (category === "Subscription") {
      // Add subscription plan dropdown - get options from props.formData
      const subscriptionPlanField = props?.formData?.find(f => f.name === "subscriptionPlanId");
      if (subscriptionPlanField) {
        tempFormData.splice(insertIndex, 0, subscriptionPlanField);
      }
    }

    // tempFormData.splice(insertIndex + 1, 0, showAsBanner);
    // tempFormData.splice(insertIndex + 2, 0, bannerPriority);

    // Handle Discount Type changes (existing logic)
    if (discountType === "Percentage") {
      const discountValueIndex = tempFormData.findIndex(field =>
        field.name === "discountValue" || field.name === "perventageValue"
      );
      if (discountValueIndex !== -1) {
        tempFormData[discountValueIndex] = flatoptions(props?.selectType).percentageValue;
      }

      // Add max discount field if not present
      const maxDiscountIndex = tempFormData.findIndex(field => field.name === "maxDiscountValue");
      if (maxDiscountIndex === -1) {
        const discountValueIndex = tempFormData.findIndex(field =>
          field.name === "discountValue" || field.name === "perventageValue"
        );
        if (discountValueIndex !== -1) {
          tempFormData.splice(discountValueIndex + 1, 0, flatoptions(props?.selectType).maxBookingPrice);
        }
      }
    } else if (discountType === "Flat") {
      const discountValueIndex = tempFormData.findIndex(field =>
        field.name === "discountValue" || field.name === "perventageValue"
      );
      if (discountValueIndex !== -1) {
        tempFormData[discountValueIndex] = flatoptions(props?.selectType).flatValue;
      }

      // Remove max discount field for flat discount
      tempFormData = tempFormData.filter(field => field.name !== "maxDiscountValue");
    }

    // Remove overall usage limit for Individual and Referral categories
    if (category === "Referral") {
      tempFormData = tempFormData.filter(field => field.name !== "overallUsageLimit");
    }

    return tempFormData;
  };

  useEffect(() => {
    if (props?.defaultValues?.id) {
      setSelectValues(props?.defaultValues);
      setValue("description", props?.defaultValues?.description || "");
      setValue("terms_conditions", props?.defaultValues?.terms_conditions || "");

      // Set up form fields only once during initialization
      const updatedFormData = setupFormFields(props.defaultValues, formData);
      setFormData(updatedFormData);

      // Set subscriptionPlanId after field is added by setupFormFields
      if (props?.defaultValues?.subscriptionPlanId) {
        setValue("subscriptionPlanId", props.defaultValues.subscriptionPlanId);
      }

      // Generic array field population
      Object.keys(props?.defaultValues).forEach(key => {
        if (Array.isArray(props?.defaultValues[key])) {
          setValue(key, props?.defaultValues[key]);
          setFacilities(prev => ({
            ...prev,
            [key]: props?.defaultValues[key],
            ...(key === 'Services' ? { dutyTypes: props?.defaultValues[key] } : {}),
            ...(key === 'ServiceCities' ? { city: props?.defaultValues[key] } : {})
          }));
        }
      });

      // Set image and CSV file states
      setImage({
        name: props?.defaultValues?.image?.name,
        file: props?.defaultValues?.image?.url,
      });
      setCsv({
        name: props?.defaultValues?.userslistUrl?.name,
        file: props?.defaultValues?.userslistUrl?.url,
      });

      // Set banner states
      if (props?.defaultValues?.isBanner) {
        const isBanner = props?.defaultValues?.isBanner || false;

        setShowAsBannerState(isBanner);

        setValue("showAsBanner", isBanner);

      }
    }
  }, [props?.defaultValues, setValue]);

  useEffect(() => {
    if (props?.formName === "couponForm") {
      register("description", { required: true });
    }
  }, [register]);

  // ReactQuill OnChange
  const onEditorStateChange = (e, value, name) => {
    clearErrors(name);
    setValue(name, e);
  };

  const quillValue = watch("description");
  const quillTermsValue = watch("terms_conditions");

  const handleInput = (e, value) => {
    clearErrors(e.target.name);

    if (e.target.name === "showAsBanner") {
      handleShowAsBannerChange(e);
      return;
    }

    if(e.target.name === "customerSeat"){
      if (e.target.value < 0) {
        setVehicleErrors({ ...vehicleerrors, [e.target.name]: "Only positive numbers greater than 0 allowed" });
        }
    }

    if(e.target.name === "category") {
      const {isValid, error} = validateFieldOnChange(formData.find(field => field.name === e.target.name), e.target.value);
      if(!isValid) {
        console.log("error", error, e.target.name);
        setVehicleErrors({ ...vehicleerrors, [e.target.name]: error });
      } else {
        setVehicleErrors({ ...vehicleerrors, [e.target.name]: "" });
      }
    }

    let data = {};
    if (value && value !== undefined) {
      data[e.target.name] = value;
    } else {
      data[e.target.name] = e.target.value;

      // Update dropdown values in state
      setSelectValues(prev => ({
        ...prev,
        [e.target.name]: e.target.value
      }));

      // Handle Category changes
      if (e.target.name === "category" && props?.formName === "couponForm") {
        // Clear related fields when category changes
        if (e.target.value === "Referral") {
          setValue("isNewUser", "");
          setValue("showAsBanner", false);
          setValue("bannerPriority", "");
          setValue("overallUsageLimit", "");
          setValue("CsvFile", "");
          setShowAsBannerState(false);
          setBannerPriorityState("");
          setCsv({ name: "", file: "" });
        } else if (e.target.value === "Individual") {
          setValue("referralType", "");
          setValue("isNewUser", "");
          setValue("showAsBanner", false);
          setValue("bannerPriority", "");
          setShowAsBannerState(false);
          setBannerPriorityState("");
        } else if (e.target.value === "Flash") {
          setValue("referralType", "");
          setValue("CsvFile", "");
          setCsv({ name: "", file: "" });
        } else if (e.target.value === "Subscription") {
          setValue("referralType", "");
          setValue("isNewUser", "");
          setValue("CsvFile", "");
          setCsv({ name: "", file: "" });
          setShowAsBannerState(false);
          setBannerPriorityState("");
        }

        // Update form data based on category
        const updatedFormData = setupFormFields({
          ...selectValues,
          [e.target.name]: e.target.value,
          discountType: selectValues.discountType || props.defaultValues?.discountType
        }, props.formData);
        setFormData(updatedFormData);
      }

      if (e.target.name === "discountType" && props?.formName === "couponForm") {
        const updatedFormData = setupFormFields({
          ...selectValues,
          [e.target.name]: e.target.value,
          category: selectValues.category || props.defaultValues?.category
        }, formData);
        setFormData(updatedFormData);
      }
    }

    let validationData = handleValidationForm(data);
    setFormError(validationData.errorVal);
    if (validationData.formIsValid) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  const handleAuto = (e, name, value) => {
    const fieldName = name || e.target.name;
    clearErrors(fieldName);

    // Update facilities state
    setFacilities(prev => ({ ...prev, [fieldName]: value }));

    // Set form value with validation
    setValue(fieldName, value, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true
    });
  };

  const handleRadio = (e, name, value) => {
    const fieldName = name || e.target.name;
    clearErrors(fieldName);
    setValue(fieldName, value);
  };

  const handleChange = (event) => {
    setCountry(event.target.value);
  };

  const handleEditIconClick = (id) => {
    props.handleEditIconClick(id);
  };
  // ---Form Validation---

  const onSubmit = (data, isDraft = false) => {
    // Validate image when showAsBanner is true
    console.log("Form Data:", data);
    if (data.showAsBanner && !image?.name) {
      setImgError("Image is required when shown as banner");
      return;
    }

    // handleValidationForm
    let validationData = handleValidationForm(data);
    setFormError(validationData.errorVal);

    if (validationData.formIsValid) {
      setIsDisabled(false);
      let submitData = { ...data };

      // Handle referral type specific data
      if (submitData.category === "Referral") {
        // Make sure referralType is included
        if (!submitData.referralType) {
          setFormError({ ...formError, referralType: "Referral type is required" });
          return;
        }

        // Remove unnecessary fields
        delete submitData.isNewUser;
        delete submitData.showAsBanner;
        delete submitData.bannerPriority;
      }

      // Sanitize terms and conditions
      if (submitData.terms_conditions) {
        submitData.terms_conditions = DOMPurify.sanitize(submitData.terms_conditions);
      }


      if (showAsBannerState) {
        submitData.isBanner = true
      } else if (props?.selectType === "edit" && !showAsBannerState) {
        submitData.isBanner = false
      }

      if(props?.formName === "couponForm") {
        if (isDraft) {
          submitData.isDraft = true;
        } else {
          submitData.isDraft = false;
        }
      }

      // Pass the actual File object for image upload
      props.onSubmittBtn(submitData, country, quillValue, image?.file, csv);
    }
  };

  const handleClose = () => {
    props.handleClose();
  };

  const handleOnError = (e) => {
    e.target.src = profile;
  };
  const onSelectDateRange = (newValue, name) => {
    clearErrors(name);
    if (newValue) {
      setValue(name, newValue);
    } else {
      setValue(name, "");
    }
  };

  const onImageChange = (event) => {
    setFileTypeError("");
    setImgError("");

    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const validImageTypes = ['image/jpeg', 'image/png', 'image/svg+xml'];

      // Check file type
      if (!validImageTypes.includes(file.type)) {
        setFileTypeError("File type should be jpg, jpeg, png or svg");
        setImage(null);
        return;
      }

      // Check file size
      if (file.size > imageSize.fiveMb) {
        setImgError("File size should not be more than 5 MB");
        setImage(null);
        return;
      }

      // Store the actual file object
      setImage({
        name: file.name,
        file: file  // Store the actual File object
      });

      // Clear banner-related error if applicable
      if (showAsBannerState) {
        setImgError("");
      }
    }
  };

  const onCSVChange = (event) => {
    setFileCsvTypeError("");
    setCsvError("");

    if (event.target.files && event.target.files[0]) {
      if (!csvReg.exec(event.target.value)) {
        const typeError = "File type should be in csv";
        setCsv(null);
        setFileCsvTypeError(typeError);
      } else if (csvReg.exec(event.target.value)) {
        if (event.target.files[0].size > imageSize.fiveMb) {
          const errorVal = "File size should not be more than 5 MB";
          setCsv(null);
          setCsvError(errorVal);
        } else {
          const img = event.target.files[0];
          setCsv(img);
        }
      } else {
        setCsv(null);
      }
    }
  };

  // ---Form Validation---
  const handelNegativeInput = (event) => {
    if (!event.target.validity.valid) {
      setValue(event?.target.name, "");
    }
  };

  const dummyFunctiom = (e) => {
    return;
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur();
    // Prevent the page/container scrolling
    e.stopPropagation();
    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  const modules = {
    toolbar: props?.disabled ? false : true,
  };

  // Image Crop
  const onImageCropChange = (event) => {
    clearErrors("avtar");
    setFileTypeError("");
    if (event.target.files && event.target.files[0]) {
      const img = event.target.files[0];
      setImageObj(event.target.files[0]);
      const attributeType = ["image/jpeg", "image/png"];
      const allowedExtensions = ["jpeg", "jpg", "png"];

      const fileExtension = img.name.split(".").pop().toLowerCase();

      if (
        !attributeType.includes(img.type) ||
        !allowedExtensions.includes(fileExtension)
      ) {
        const typeError = "File type should be in png/jpg/jpeg";
        setFileTypeError(typeError);
        setImgPlaceholder(true);
      } else if (event.target.files[0].size > imageSize) {
        const errorVal = "Image size should not be more than 1 MB";
        setImgError(errorVal);
        setImgPlaceholder(true);
      } else {
        setFileTypeError("");
        setSrc(URL.createObjectURL(img));
        setModalOpen(true);
        setValue("avtar", URL.createObjectURL(img));
        if (img) {
          setImgPlaceholder(true);
        }
      }
      event.target.value = "";
    }
  };
  const handleCropSave = (blob) => {
    setImageCrop(URL.createObjectURL(blob));
    const file = new File([blob], imageObj?.name, { lastModified: new Date() });
    props?.onImageHandleChange(file);
  };

  const handleErrorImg = (event) => {
    const typeError = "Please choose proper image";
    setFileTypeError(typeError);
    setModalOpen(false);
  };

  const handleCloseModal = () => {
    setModalOpen(false); // Close the modal
  };

  const handleShowAsBannerChange = (event) => {
    setShowAsBannerState(event.target.checked);
    setValue("showAsBanner", event.target.checked);

    // Update form data to make couponImage required if showAsBanner is checked
    if (event.target.checked && !image?.name) {
      setImgError("Image is required when shown as banner");
    } else {
      setImgError("");
    }

    // Update banner priority field state
    const updatedFormData = formData.map(field => {
      if (field.name === 'bannerPriority') {
        return { ...field, disabled: !event.target.checked };
      }
      return field;
    });
    setFormData(updatedFormData);
  };

  const handleBannerPriorityChange = (event) => {
    setBannerPriorityState(event.target.value);
    setValue("bannerPriority", event.target.value);
  };

  const downloadCSVTemplate = () => {
    // Define your CSV template structure
    const csvContent = `Mobile,Name,Email
  9876543210,John Doe,example1@email.com
  9876543211,Jane Smith,example2@email.com`;

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'csv-template.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };


  return (
    <div>
      <div>
        {/* "handleSubmit" will validate your inputs before invoking "onSubmit"  */}
        <form
          onSubmit={handleSubmit((data) => onSubmit(data, false))}
          className={`${props.type === "complianceupload" ? "flexDirection" : null
            }`}
        >
          <Grid
            container
            spacing={{ md: 2 }}
            columns={{ xs: 1, sm: 3, md: 12 }}
          >
            {formData?.map((ele, idx) => (
              <Grid item xs={12} sm={ele.gridSize} key={idx} sx={ele?.alignCenter ? { display: 'flex', alignItems: 'center' } : {}}>
                <div
                  key={ele?.name}
                  className={ele?.name === "description" ? "mb25" : null}
                >
                  {ele.type === "file" ? (
                    <CommonCropUpload
                      name={ele?.name}
                      defaultValues={props?.defaultValues}
                      onImageHandleChange={props?.onImageHandleChange}
                    />
                  ) : (
                    ele?.name !== "InsuranceFile" &&
                    ele?.name !== "PollutionFile" &&
                    ele?.name !== "RCBookFile" && (
                      <Box
                        className={
                          idx === formData?.length - 1
                            ? "boxOutline"
                            : "boxMarginBottom"
                        }
                        key={ele?.name}
                      >
                        <FormControl variant="standard">
                          <p className="commonformLabel">
                            {ele?.label}
                            {(ele?.required || ele?.starVal) && (
                              <span className="colorRed">
                                {ele?.star || "*"}
                              </span>
                            )}
                            {/* Add template download link for CSV fields */}
                            {ele?.csvFileUpload && (
                              <span style={{ marginLeft: '10px' }}>
                                <Typography
                                  variant="body2"
                                  component="span"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    downloadCSVTemplate();
                                  }}
                                  style={{
                                    color: '#1976d2',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    fontWeight: 'normal'
                                  }}
                                >
                                  (Download Template)
                                </Typography>
                              </span>
                            )}
                          </p>
                          <Box
                            className={
                              ele?.name === "description"
                                ? "mb25 dflex"
                                : "dflex"
                            }
                          >
                            {ele?.countrycode && (
                              <FormControl className="width100px marginRight10">
                                <Select
                                  value={country ? country : "+91"}
                                  onChange={handleChange}
                                  inputProps={{ "aria-label": "Without label" }}
                                >
                                  <MenuItem
                                    className="colorBlack"
                                    value={"+91"}
                                  >
                                    +91
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            )}
                            <FormControl
                              fullWidth
                              className="commonFormControl"
                            >
                              {ele?.name === "showAsBanner" ? (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      {...register(ele?.name)}
                                      checked={showAsBannerState}
                                      onChange={handleShowAsBannerChange}
                                      disabled={ele?.disabled || props?.disabled}
                                    />
                                  }
                                  label={ele?.label}
                                />
                              ) : ele?.name === "bannerPriority" ? (
                                <Select
                                  {...register(ele?.name, {
                                    required: showAsBannerState ? ele?.required : false,
                                  })}
                                  value={bannerPriorityState}
                                  onChange={handleBannerPriorityChange}
                                  disabled={!showAsBannerState}
                                  displayEmpty
                                  inputProps={{ "aria-label": "Without label" }}
                                >
                                  <InputLabel disabled className="colorGrey marginLeft16">
                                    <Typography className="colorGrey" variant="body2">
                                      {!bannerPriorityState && ele.placeholder}
                                    </Typography>
                                  </InputLabel>
                                  {ele?.options?.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              )
                                : ele?.options ? (
                                  <>
                                    <Controller
                                      name={ele.name}
                                      control={control}
                                      defaultValue={
                                        selectValues?.[ele.name] ??
                                        props?.defaultValues?.[ele.name] ??
                                        ""
                                      }
                                      rules={{ required: ele.required || false }}
                                      render={({ field }) => (
                                        <>
                                          <InputLabel
                                            shrink={!!field.value}
                                            className="colorGrey marginLeft16"
                                            htmlFor={ele.name}
                                          >
                                            <Typography className="colorGrey" variant="body2">
                                              {!field.value ? ele.placeholder : ""}
                                            </Typography>
                                          </InputLabel>
                                          <Select
                                            {...field}
                                            id={ele.name}
                                            displayEmpty
                                            inputProps={{ "aria-label": "Without label" }}
                                            value={field.value}
                                            onChange={(e) => {
                                              field.onChange(e.target.value);
                                              handleInput(e);
                                            }}
                                            disabled={ele?.disabled || props?.disabled}
                                          >
                                            {ele.options.map((option) => (
                                              <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </>
                                      )}
                                    />
                                  </>
                                ) : ele?.radio ? (
                                  <FormControl>
                                    <Controller
                                      name={ele?.name}
                                      control={control}
                                      rules={{ required: ele?.required }}
                                      render={({ field }) => (
                                        <RadioGroup
                                          row
                                          aria-labelledby="demo-row-radio-buttons-group-label"
                                          name={field.name}
                                          value={field.value}
                                          onChange={(event, value) => {
                                            field.onChange(value);
                                            handleRadio(event, ele.name, value);
                                          }}
                                        >
                                          {ele?.radio.map((value) => (
                                            <FormControlLabel
                                              key={value?.name}
                                              value={value?.value}
                                              control={
                                                <Radio
                                                  disabled={ele?.disabled || props?.disabled}
                                                />
                                              }
                                              label={value?.label}
                                            />
                                          ))}
                                        </RadioGroup>
                                      )}
                                    />
                                  </FormControl>
                                ) : ele?.autoComplete ? (
                                  <Box
                                    className="customAutocomplete"
                                    sx={{
                                      maxHeight: "120px",
                                      overflow: "auto",
                                    }}
                                  >
                                    <Controller
                                      name={ele?.name}
                                      control={control}
                                      rules={{
                                        required: ele?.required || false,
                                        validate: (value) => {
                                          if (ele?.required && (!value || value.length === 0)) {
                                            return `${ele?.label || 'This field'} is required`;
                                          }
                                          return true;
                                        }
                                      }}
                                      defaultValue={facilities[ele?.name] || []}
                                      render={({ field, fieldState: { error } }) => (
                                        <Autocomplete
                                          {...field}
                                          multiple
                                          id="size-small-standard-multi"
                                          size="medium"
                                          options={props?.optionData ? props?.optionData : ele?.option}
                                          filterOptions={(options, state) => {
                                            const inputValue = state.inputValue.toLowerCase();
                                            return options.filter((option) =>
                                              option.name.toLowerCase().includes(inputValue)
                                            );
                                          }}
                                          getOptionLabel={(option) => option.name || ''}
                                          value={facilities[ele?.name] || []}
                                          onChange={(event, newValue) => {
                                            field.onChange(newValue);
                                            handleAuto(event, ele?.name, newValue);
                                          }}
                                          disabled={ele?.disabled || props?.disabled}
                                          filterSelectedOptions
                                          isOptionEqualToValue={(option, value) => option.id === value.id}
                                          renderOption={(props, option) => (
                                            <Box
                                              component="li"
                                              className="marginRight6"
                                              {...props}
                                            >
                                              {option?.img?.url && (
                                                <IconButton color="primary">
                                                  <img
                                                    loading="lazy"
                                                    width="20"
                                                    height="20"
                                                    src={option?.img?.url}
                                                    alt=""
                                                  />
                                                </IconButton>
                                              )}
                                              {option.name}
                                            </Box>
                                          )}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              margin="normal"
                                              error={!!errors[ele?.name]}
                                              helperText={errors[ele?.name]?.message}
                                              aria-label={`Add ${ele?.label || 'Items'}`}
                                              placeholder={props?.formName !== "couponDetailsForm" && ele?.placeholder}
                                              inputProps={{
                                                ...params.inputProps,
                                                autoComplete: "disabled",
                                              }}
                                            />
                                          )}
                                        />
                                      )}
                                    />
                                  </Box>
                                ) : ele?.quill ? (
                                  <ReactQuill
                                    theme="snow"
                                    value={
                                      ele.name === "terms_conditions"
                                        ? quillTermsValue
                                        : quillValue
                                    }
                                    onChange={(e, value) =>
                                      onEditorStateChange(e, value, ele.name)
                                    }
                                    readOnly={ele?.disabled}
                                    modules={modules}
                                  />
                                ) : ele?.dateRangePicker ? (
                                  <Box className="customDateRangePicker">
                                    <DateTab
                                      {...register(ele?.name, {
                                        required: true,
                                      })}
                                      disabled={ele?.disabled}
                                      onSelectDateRange={(value) =>
                                        onSelectDateRange(value, ele?.name)
                                      }
                                      dateFrom={selectValues?.startDate}
                                      dateTo={selectValues?.endDate}
                                      minDate={
                                        props?.formName === "couponForm"
                                          ? new Date()
                                          : false
                                      }
                                      allowFutureDates={
                                        props?.formName === "couponForm"
                                      }
                                    />
                                  </Box>
                                ) : ele?.fileUpload ? (
                                  <Box
                                    className={`customFileUploader ${(ele?.fieldDisabled || props?.disabled) &&
                                      "disabled"
                                      }`}
                                  >
                                    {image?.name && (
                                      <>
                                        <img
                                          src={
                                            props?.defaultValues.image
                                              ? image?.file
                                              : (image?.file instanceof File ? URL.createObjectURL(image?.file) : image?.file)
                                          }
                                          className="width100 height122"
                                          alt="img"
                                        />
                                      </>
                                    )}
                                    {props?.formName !== "couponDetailsForm" && (
                                      <Button
                                        // ref={uploadFileRef}
                                        variant="contained"
                                        component="label"
                                        className="fileUploader commonBorder"
                                        disabled={
                                          ele?.disabled || props?.disabled
                                        }
                                      >
                                        <Box className="fileUploadContainer justifyCenter">
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              component={"h5"}
                                              className="colorGrey fw400 justifyCenter textCapitalize"
                                            >
                                              {ele?.placeholder
                                                ? ele?.placeholder
                                                : "Upload Contract"}
                                              <Typography
                                                component={"span"}
                                                variant="head4"
                                                className=" fw400 "
                                              >
                                                {/* <img
                                          src={lockicon}
                                          className="marginInline10"
                                          alt="image"
                                        /> */}
                                              </Typography>
                                            </Typography>
                                          </Box>

                                          <input
                                            type="file"
                                            {...register(ele?.name, {
                                              required: image?.name
                                                ? false
                                                : ele?.required,
                                              onChange: (e) => onImageChange(e),
                                            })}
                                            hidden
                                            accept=".jpg,.jpeg,.png,.svg"
                                          />
                                        </Box>
                                      </Button>
                                    )}

                                    {imgError && imgError !== null && (
                                      <Typography
                                        variant={"body2"}
                                        className="errorMessage"
                                      >
                                        {imgError}
                                      </Typography>
                                    )}
                                    {fileTypeError && fileTypeError !== null && (
                                      <Typography
                                        variant={"body2"}
                                        className="errorMessage"
                                      >
                                        {imgError}
                                      </Typography>
                                    )}
                                  </Box>
                                ) : ele?.csvFileUpload ? (
                                  <>
                                    {props?.formName === "couponDetailsForm" ? (
                                      <>
                                        <Box className="justifyAlignCenter height122 borderForm">
                                          <Typography
                                            variant="body2"
                                            component={"h5"}
                                            className="colorGrey fw400 justifyCenter textCapitalize"
                                          >
                                            <a
                                              href={csv?.file}
                                              target="_blank"
                                              className="colorGrey fw400 justifyCenter textCapitalize"
                                            >
                                              {csv?.name}{" "}
                                              <img
                                                src={downloadBlue}
                                                className="marginInline10"
                                                alt="image"
                                              />
                                            </a>
                                          </Typography>
                                        </Box>{" "}
                                      </>
                                    ) : (
                                      <Box
                                        className={`customFileUploader ${(ele?.fieldDisabled ||
                                          props?.disabled) &&
                                          "disabled"
                                          }`}
                                      >
                                        <Button
                                          // ref={uploadFileRef}
                                          variant="contained"
                                          component="label"
                                          className="fileUploader commonBorder"
                                          disabled={
                                            ele?.fieldDisabled || props?.disabled
                                          }
                                        >
                                          <Box className="fileUploadContainer justifyCenter">
                                            <Box>
                                              <Typography
                                                variant="body2"
                                                component={"h5"}
                                                className="colorGrey fw400 justifyCenter textCapitalize"
                                              >
                                                {ele?.placeholder
                                                  ? ele?.placeholder
                                                  : "Upload Contract"}
                                                <Typography
                                                  component={"span"}
                                                  variant="head4"
                                                  className=" fw400 "
                                                >
                                                  {/* <img
                                                      src={lockicon}
                                                      className="marginInline10"
                                                      alt="image"
                                                    /> */}
                                                </Typography>
                                              </Typography>
                                            </Box>

                                            <input
                                              type="file"
                                              {...register(ele?.name, {
                                                required: csv?.name
                                                  ? false
                                                  : ele?.required,
                                                onChange: (e) => onCSVChange(e),
                                              })}
                                              hidden
                                              accept=".csv"
                                            />
                                          </Box>
                                        </Button>
                                        {csv?.name && (
                                          <>
                                            <Typography>{csv.name}</Typography>
                                          </>
                                        )}
                                        {csvError && csvError !== null && (
                                          <Typography
                                            variant={"body2"}
                                            className="errorMessage"
                                          >
                                            {csvError}
                                          </Typography>
                                        )}
                                        {fileCsvTypeError &&
                                          fileCsvTypeError !== null && (
                                            <Typography
                                              variant={"body2"}
                                              className="errorMessage"
                                            >
                                              {fileCsvTypeError}
                                            </Typography>
                                          )}
                                      </Box>
                                    )}
                                  </>
                                ) : ele?.textField ? (
                                  <CustomTextfield
                                    ele={ele}
                                    handleInput={handleInput}
                                    props={props}
                                    register={register}
                                    errors={errors}
                                    formError={formError}
                                    handelNegativeInput={handelNegativeInput}
                                    dummyFunctiom={dummyFunctiom}
                                    disable={ele?.disabled || props?.disabled}
                                    numberInputOnWheelPreventChange={
                                      numberInputOnWheelPreventChange
                                    }
                                  />
                                ) : ele.type === "vehicleImg" ? (
                                  <>
                                    <Button
                                      variant="contained"
                                      component="label"
                                      className="uploadBtn"
                                    >
                                      <CommonCropImage
                                        modalOpen={modalOpen}
                                        src={src}
                                        setModalOpen={setModalOpen}
                                        handleCropSave={handleCropSave}
                                        handleCloseModal={handleCloseModal}
                                      />
                                      <img
                                        src={
                                          imageCrop && imageCrop != null
                                            ? imageCrop
                                            : props?.defaultValues?.avtar?.url
                                              ? props?.defaultValues?.avtar?.url
                                              : profileImg
                                        }
                                        alt="profile1"
                                        className="imgFormSize"
                                      />
                                      {src && (
                                        <img
                                          src={src}
                                          alt="profile"
                                          className="imgFormSize"
                                          style={{ display: "none" }}
                                          onError={handleErrorImg}
                                        />
                                      )}
                                      <div className="imgOuter">
                                        <img src={camera} alt="camera" />
                                      </div>
                                      <input
                                        type="file"
                                        {...register(ele?.name, {
                                          required:
                                            src ||
                                              props?.defaultValues?.avtar?.url
                                              ? false
                                              : ele?.required,
                                          onChange: (e) => onImageCropChange(e),
                                        })}
                                        hidden
                                        accept="image/*"
                                      />
                                    </Button>
                                    {props?.defaultValues?.avtar?.url ||
                                      imgPlaceholder ? (
                                      ""
                                    ) : (
                                      <div className="errorMessage">
                                        Image is required
                                      </div>
                                    )}
                                    {imgError && imgError !== null && (
                                      <div className="errorMessage">
                                        {imgError}
                                      </div>
                                    )}
                                    {fileTypeError && fileTypeError !== null && (
                                      <div className="errorMessage">
                                        {fileTypeError}
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  ele?.type !== "file" &&
                                  ele?.type !== "csvFile" &&
                                  ele?.type !== "radio" && (
                                    <BootstrapInput
                                      placeholder={ele?.placeholder}
                                      {...register(ele?.name, {
                                        required: ele?.required || false,
                                        onChange: (e) => {
                                          handleInput(e);
                                        },
                                      })}
                                      type={ele?.type || "text"}
                                      id="bootstrap-input"
                                      error={
                                        vehicleerrors[ele?.name] || errors[ele?.name] || formError[ele?.name]
                                      }
                                      disabled={
                                        ele?.editProps &&
                                          props?.editIconId === ele?.id
                                          ? false
                                          : ele?.disabled || false
                                      }
                                      multiline={ele?.multiline || false}
                                      rows={ele?.row || ""}
                                      defaultValue={ele?.defaultValue}
                                      onWheel={numberInputOnWheelPreventChange}
                                      endAdornment={
                                        <InputAdornment
                                          className="margin0"
                                          position="start"
                                        >
                                          {ele?.disabled &&
                                            ele?.disabled === true &&
                                            !ele?.editProps && (
                                              <IconButton className="editIconCommon cursorAuto">
                                                <img
                                                  src={lockicon}
                                                  alt="lockicon"
                                                />
                                              </IconButton>
                                            )}
                                        </InputAdornment>
                                      }
                                    />
                                  )
                                )}
                            </FormControl>
                            {ele?.editProps && props?.editIconId === ele?.id ? (
                              <Box>
                                <Grid
                                  container
                                  xs={12}
                                  sm={12}
                                  className="verifyButtonAlign"
                                >
                                  <Grid item>
                                    <Button
                                      variant="contained"
                                      size="medium"
                                      className={`mt0 ${isDisabled
                                        ? "verifyDisabled"
                                        : "verifyBtn"
                                        }`}
                                      type="verify"
                                      fullWidth
                                      disabled={isDisabled}
                                    >
                                      Verify
                                    </Button>
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      variant="contained"
                                      size="medium"
                                      className="cancelButton"
                                      type="cancel"
                                      fullWidth
                                      onClick={() => handleEditIconClick("")}
                                    >
                                      Cancel
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Box>
                            ) : null}
                          </Box>
                          {/* errors will return when field validation fails  */}
                          {errors[ele?.name] && (
                            <div
                              className={`errorMessage ${ele?.name === "description" ? "marginTop25" : ""
                                }`}
                            >
                              This field is required
                            </div>
                          )}
                          {formError[ele?.name] && (
                            <div className="errorMessage">
                              {formError[ele?.name]}
                            </div>
                          )}
                          {vehicleerrors[ele?.name] && (
                            <div className="errorMessage">
                              {vehicleerrors[ele?.name]}
                            </div>
                          )}
                          {props?.locationError && (
                            <div className="colorRed">
                              {props?.locationError}
                            </div>
                          )}
                        </FormControl>
                      </Box>
                    )
                  )}
                  {(ele?.name === "InsuranceFile" ||
                    ele?.name === "PollutionFile" ||
                    ele?.name === "RCBookFile" ||
                    ele.name === "") && (
                      <Button
                        variant="contained"
                        component="label"
                        className="uploadDocsBtn"
                      >
                        <img src={cloudArrowUp} alt="profile" />
                        <span className="uploadTextStyle">Upload</span>
                        <input type="file" hidden />
                      </Button>
                    )}
                </div>
              </Grid>
            ))}
          </Grid>
          {props?.button && props?.button !== "dialogButton" && (
            <Box>
              <Grid container>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    size="medium"
                    className={`buttonSubmit ${isDisabled ? "buttonSubmitDisabled" : ""
                      }`}
                    type="submit"
                    fullWidth
                    disabled={isDisabled} // Disable button if no form field value is present
                  >
                    {props.loading ? <Loader height={"10px"} /> : props?.button}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}
          {props?.button && props?.button === "dialogButton" && (
            <Box marginTop={3}>
              <Grid container className="btnDialogContainer" spacing={2}>

                {/* Left Side: Cancel */}
                <Grid item xs={12} sm={4}>
                  <Button
                    variant="contained"
                    size="medium"
                    className="cancelAddBtn"
                    fullWidth
                    onClick={() => handleClose()}
                  >
                    Cancel
                  </Button>
                </Grid>

                {/* Right Side: Save + Create side-by-side */}
                <Grid item xs={12} sm={8}>
                  <Grid container spacing={2}>
                    {props.enableSaveAsDraft && (
                      <Grid item xs={6}>
                        <Button
                          variant="contained"
                          size="medium"
                          className={`draftBtn ${isDisabled ? "draftBtnDisabled" : ''}`}
                          fullWidth
                          onClick={handleSubmit((data) => onSubmit(data, true))}
                        >
                          Save as Draft
                        </Button>
                      </Grid>
                    )}
                    <Grid item xs={props.enableSaveAsDraft ? 6 : 12}>
                      <Button
                        variant="contained"
                        size="medium"
                        className={`buttonSubmit ${isDisabled ? "buttonSubmitDisabled" : ""}`}
                        type="submit"
                        disabled={isDisabled}
                        fullWidth
                      >
                        {props?.selectType === "edit"
                          ? "Update"
                          : props?.selectType === "Send"
                            ? "Send"
                            : "Create"}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>

              </Grid>
            </Box>

          )}
        </form>
      </div>
    </div>
  );
}